// src/components/partner/CoBrandLogo.jsx
// Drop-in for <Logo /> in page headers and the Navbar.
//   No partner involved -> the normal RouteChef <Logo />
//   Partner signed in, or customer came from a partner's link
//                       -> partner logo + name, "with Routechef" underneath (co-branding:
//                          RouteChef Labs Pvt Ltd makes and services the bookings)
import React from "react";
import { Link } from "react-router-dom";
import Logo from "../common/Logo";
import { usePartnerBrand } from "../../utils/partnerBrand";

const ROUTECHEF_LOGO_URL = "/logo_new.svg";

// compactOnMobile: on phones show only the partner logo (for tight bars like the bus booking header)
export default function CoBrandLogo({ to = "/", compactOnMobile = false, ...logoProps }) {
    const brand = usePartnerBrand();
    if (!brand?.name) return <Logo {...logoProps} />;
    return (
        <Link to={to} style={S.wrap} aria-label={`${brand.name}, with RouteChef`} title={`${brand.name} · Bookings by RouteChef Labs Pvt Ltd`}>
            {brand.logo
                ? <span style={S.logoBox}><img src={brand.logo} alt="" style={S.logoImg} /></span>
                : <span style={S.initial}>{brand.name.trim().charAt(0).toUpperCase()}</span>}
            <span style={{ minWidth: 0, lineHeight: 1.15 }} className={compactOnMobile ? "cbl-text cbl-text--hide" : "cbl-text"}>
                <span style={S.name} className="cbl-name">{brand.name}</span>
                <span style={S.with}>
                    with <img src={ROUTECHEF_LOGO_URL} alt="" style={S.rc} />
                    <b style={{ color: "#FF5B15" }}>Route</b><span style={{ color: "#0F172A", fontWeight: 600 }}>chef</span>
                </span>
            </span>
            <style>{`.cbl-name{max-width:280px}@media (max-width:640px){.cbl-name{max-width:150px !important;font-size:14px !important}.cbl-text--hide{display:none !important}}`}</style>
        </Link>
    );
}

const S = {
    wrap: { display: "inline-flex", alignItems: "center", gap: 10, textDecoration: "none", minWidth: 0, fontFamily: "'Inter', -apple-system, system-ui, sans-serif" },
    logoBox: { display: "inline-flex", alignItems: "center", justifyContent: "center", height: 40, maxWidth: 110, padding: "0 4px", borderRadius: 8, background: "#fff", border: "1px solid #E2E8F0", flexShrink: 0, boxSizing: "border-box" },
    logoImg: { maxHeight: 32, maxWidth: 100, objectFit: "contain", display: "block" },
    initial: { width: 40, height: 40, borderRadius: 10, background: "#1E293B", color: "#fff", fontWeight: 800, fontSize: 18, display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
    name: { display: "block", fontSize: 16, fontWeight: 800, color: "#0F172A", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
    with: { display: "inline-flex", alignItems: "center", gap: 3, fontSize: 11.5, color: "#64748B", marginTop: 2 },
    rc: { width: 13, height: 13, marginLeft: 2 },
};
